<template>
    <b-container class="admin-container">
        <div class="card-holder">
            <div class="nav-card" style="--card-color: #3b82f6" @click="goToQuestionnaires">
                <div class="nav-card-icon-bubble">
                    <font-awesome-icon :icon="['fas', 'poll']" />
                </div>
                <div class="nav-card-text">
                    <span class="nav-card-label">Questionnaires</span>
                    <span class="nav-card-desc">Manage survey questionnaires</span>
                </div>
            </div>
            <div class="nav-card" style="--card-color: #f59e0b" @click="goToCreateQuestion">
                <div class="nav-card-icon-bubble">
                    <font-awesome-icon :icon="['fas', 'question']" />
                </div>
                <div class="nav-card-text">
                    <span class="nav-card-label">Create Question</span>
                    <span class="nav-card-desc">Add new survey questions</span>
                </div>
            </div>
            <div class="nav-card" style="--card-color: #22c55e" @click="goToAccountRequests">
                <div class="nav-card-icon-bubble">
                    <font-awesome-icon :icon="['fas', 'suitcase']" />
                </div>
                <div class="nav-card-text">
                    <span class="nav-card-label">Account Requests</span>
                    <span class="nav-card-desc">Review pending accounts</span>
                </div>
            </div>
          <div class="nav-card" style="--card-color: #ef4444" @click="goToLoginAudit">
            <div class="nav-card-icon-bubble">
              <font-awesome-icon :icon="['fas', 'sign-in-alt']"/>
            </div>
            <div class="nav-card-text">
              <span class="nav-card-label">Login Auditing</span>
              <span class="nav-card-desc">Review login activity</span>
            </div>
          </div>
          <div class="nav-card" style="--card-color: #0ea5e9" @click="goToExternalResources">
            <div class="nav-card-icon-bubble">
              <font-awesome-icon :icon="['fas', 'link']"/>
            </div>
            <div class="nav-card-text">
              <span class="nav-card-label">Resource Links</span>
              <span class="nav-card-desc">Configure external links</span>
            </div>
          </div>
          <div class="nav-card" style="--card-color: #f97316" @click="goToNotificationEditor">
            <div class="nav-card-icon-bubble">
              <font-awesome-icon :icon="['fas', 'envelope-open']"/>
            </div>
            <div class="nav-card-text">
              <span class="nav-card-label">Notification Editor</span>
              <span class="nav-card-desc">Edit notification templates</span>
            </div>
          </div>
          <div class="nav-card" style="--card-color: #64748b" @click="goToUserList">
            <div class="nav-card-icon-bubble">
              <font-awesome-icon :icon="['fas', 'users']"/>
            </div>
            <div class="nav-card-text">
              <span class="nav-card-label">User List</span>
              <span class="nav-card-desc">Manage system users</span>
            </div>
          </div>
          <div class="nav-card" style="--card-color: #8b5cf6" @click="goToChecklistEditor">
            <div class="nav-card-icon-bubble">
              <font-awesome-icon :icon="['fas', 'list-alt']"/>
            </div>
            <div class="nav-card-text">
              <span class="nav-card-label">Checklist Editor</span>
              <span class="nav-card-desc">Edit checklist sections</span>
            </div>
          </div>
        </div>

        <h5 class="section-heading">Reporting</h5>
        <div class="reporting-table-wrapper">
            <b-table :fields="reportingFields" :items="reportingRows" bordered fixed>
                <template #cell(parameters)>
                    <div class="param-row">
                        <b-form-group label="Start Year" label-size="sm" label-cols="auto"
                                      label-align="left" class="param-group">
                            <b-form-input type="number" v-model.number="exportStartYear"
                                          min="1900" max="2100" size="sm" style="width: 90px;" />
                        </b-form-group>
                        <b-form-group label="End Year" label-size="sm" label-cols="auto"
                                      label-align="left" class="param-group">
                            <b-form-input type="number" v-model.number="exportEndYear"
                                          min="1900" max="2100" size="sm" style="width: 90px;" />
                        </b-form-group>
                    </div>
                    <b-form-invalid-feedback :state="exportYearRangeValid || !(exportStartYear && exportEndYear)">
                        End year must be &ge; start year and both must be &ge; 1900.
                    </b-form-invalid-feedback>
                </template>
                <template #cell(action)>
                    <b-button pill variant="primary" size="sm"
                              :disabled="!exportYearRangeValid"
                              @click="downloadAggregateExport">
                        Download Excel
                    </b-button>
                </template>
            </b-table>
        </div>
    </b-container>
</template>

<script>
import {FileUtils} from '../lib/FileUtils';

export default {
        data() {
            return {
                exportStartYear: null,
                exportEndYear: new Date().getFullYear(),
                reportingFields: [
                    { key: 'report', label: 'Report', thStyle: { width: '220px' } },
                    { key: 'parameters', label: 'Parameters' },
                    { key: 'action', label: 'Action', thStyle: { width: '160px' } }
                ],
                reportingRows: [
                    { report: 'Aggregate Metrics Export' }
                ]
            };
        },
        computed: {
            exportYearRangeValid() {
                return this.exportStartYear >= 1900
                    && this.exportEndYear >= 1900
                    && this.exportEndYear >= this.exportStartYear;
            }
        },
        methods: {
            goToQuestionnaires: function () {
                console.log("Logging in.")
                this.$router.push({path: '/questionnaire-admin'});
            },
            goToCreateQuestion: function () {
                console.log("Logging in.")
                this.$router.push({path: '/create-question'});
            },
            goToAccountRequests: function () {
                console.log("Logging in.")
                this.$router.push({path: '/review-requests'});
            },
          goToUserList: function () {
            this.$router.push({path: '/users'});
          },
          goToNotificationEditor: function () {
            this.$router.push({path: '/edit/notification'});
          },
          goToExternalResources: function () {
            this.$router.push({path: '/external-resources'});
          },
          goToLoginAudit: function () {
            this.$router.push({path: '/login-admin'});
          },
          goToChecklistEditor: function () {
            this.$router.push({path: '/vineyard-editor', query: {checklistType: 'VINEYARD'}});
          },
            async downloadAggregateExport() {
              const preparing = this.$toasted.show('Preparing your report...', {duration: null});
                try {
                    const response = await this.$http.get('/metrics/admin/export', {
                        params: {
                            startYear: this.exportStartYear,
                            endYear: this.exportEndYear
                        },
                        responseType: 'blob'
                    });
                  preparing.goAway(0);
                    FileUtils.saveExcelToDisk(response);
                } catch (e) {
                    console.error('Aggregate export failed', e);
                  preparing.goAway(0);
                  this.$toasted.error('Export failed. Please check the year range and try again.');
                }
            }
        }
    }
</script>


<style scoped>

    .admin-container {
        width: 95%;
        margin-top: 10px;
    }

    .card-holder {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 24px;
    }

    .nav-card {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 14px;
        padding: 14px 20px;
        min-width: 210px;
        border-radius: 12px;
        border: 2px solid #e2e8f0;
        background: white;
        cursor: pointer;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
        transition: all 0.18s ease;
        user-select: none;
    }

    .nav-card:hover {
        border-color: var(--card-color);
        background: color-mix(in srgb, var(--card-color) 8%, white);
        box-shadow: 0 0 0 3px color-mix(in srgb, var(--card-color) 16%, transparent);
    }

    .nav-card:hover .nav-card-icon-bubble {
        background: color-mix(in srgb, var(--card-color) 16%, white);
        color: var(--card-color);
    }

    .nav-card:hover .nav-card-label {
        color: var(--card-color);
    }

    .nav-card-icon-bubble {
        width: 42px;
        height: 42px;
        border-radius: 10px;
        background: #f1f5f9;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: #94a3b8;
        font-size: 1.1rem;
        transition: all 0.18s ease;
    }

    .nav-card-text {
        display: flex;
        flex-direction: column;
    }

    .nav-card-label {
        font-weight: 600;
        font-size: 0.95rem;
        color: #1e293b;
        transition: color 0.18s;
    }

    .nav-card-desc {
        font-size: 0.78rem;
        color: #94a3b8;
        margin-top: 2px;
    }

    .section-heading {
        margin-bottom: 12px;
        font-weight: 600;
    }

    .reporting-table-wrapper {
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid #dee2e6;
    }

    .reporting-table-wrapper table {
        margin-bottom: 0;
    }

    .param-row {
        display: flex;
        gap: 16px;
        align-items: flex-start;
    }

    .param-group {
        margin-bottom: 0;
    }

</style>
